/**
 * proctorHelper.ts
 * Used for managing Proctor Groups functionality related to view jobs
 */

/**
 * Proctor status constants
 */
const PROCTOR_STATUS = {
    INACTIVE: -1,
    CONTROL: 0,
    CONTROL_AA: 1,
    ACTIVE: 2,
};

/**
 * Proctor groups constants
 */
export const PROCTOR_GROUPS = {
    JOB_FEEDBACK_PROMPT: 'magua_job_feedback_prompt_tst',
    SHARE_TOOLTIP: 'rn_magua_share_tooltip_tst',
};

/**
 * Check if a specific feature is enabled
 * @param proctorGroups Array of proctor groups
 * @param proctor Proctor group identifier to check
 * @returns Whether the feature is enabled
 * @deprecated Logging strings should not be used to test for proctor allocation
 */
const isFeatureEnabled = (proctorGroups: string | undefined | null, proctor: string): boolean => {
    return Boolean(proctorGroups?.includes(`${proctor}${PROCTOR_STATUS.ACTIVE}`));
};

/**
 * Check if job feedback prompt feature is enabled
 * @param proctorGroups Array of proctor groups
 * @returns Whether the job feedback prompt feature is enabled
 * @deprecated Logging strings should not be used to test for proctor allocation
 */
export const isJobFeedbackPromptEnabled = (proctorGroups: string | undefined | null): boolean => {
    return isFeatureEnabled(proctorGroups, PROCTOR_GROUPS.JOB_FEEDBACK_PROMPT);
};

/**
 * Check if share tooltip feature is enabled
 * @param proctorGroups Array of proctor groups
 * @returns Whether the share tooltip feature is enabled
 * @deprecated Logging strings should not be used to test for proctor allocation
 */
export const isShareTooltipEnabled = (proctorGroups: string | undefined | null): boolean => {
    return isFeatureEnabled(proctorGroups, PROCTOR_GROUPS.SHARE_TOOLTIP);
};

export { isFeatureEnabled };
